import { i18n } from 'i18n';
import { h } from '@stencil/core';
import initParams from 'store/initParams';

export default function BaggageDetail({ bags }: { bags: { backpack: number; handbag: number; suitcase: number } }) {
  return (
    <div class="baggage-container">
      <div class={`eva-3-luggage ${initParams.isMobile ? '-border' : '-column-layout'}`}>
        <div class="luggage-title -eva-3-mb-md"> {i18n.t.flightDetailModal.baggage.title} </div>
        <ul class="luggage-list">
          <li class="luggage-item">
            <span class={{ 'luggage-item': true, '-included': bags.backpack > 0 }}>
              <div class="luggage-item-icon eva-3-icon-backpack-filled -eva-3-icon-md"></div>
              <div class="luggage-item-content">
                <div class="luggage-item-title">
                  {bags.backpack > 0 ? i18n.t.flightDetailModal.baggage.backpack.included.title : i18n.t.flightDetailModal.baggage.backpack.notIncluded.title}
                </div>
                <div class="luggage-item-description">
                  <p>{bags.backpack > 0 ? i18n.t.flightDetailModal.baggage.backpack.included.description : i18n.t.flightDetailModal.baggage.backpack.notIncluded.description}</p>
                </div>
              </div>
            </span>
          </li>
          <li class="luggage-item">
            <span class={{ 'luggage-item': true, '-included': bags.handbag > 0 }}>
              <div class="luggage-item-icon eva-3-icon-handbag-filled -eva-3-icon-md"></div>
              <div class="luggage-item-content">
                <div class="luggage-item-title">
                  {bags.handbag > 0 ? i18n.t.flightDetailModal.baggage.handbag.included.title : i18n.t.flightDetailModal.baggage.handbag.notIncluded.title}
                </div>
                <div class="luggage-item-description">
                  <p>{bags.handbag > 0 ? i18n.t.flightDetailModal.baggage.handbag.included.description : i18n.t.flightDetailModal.baggage.handbag.notIncluded.description}</p>
                </div>
              </div>
            </span>
          </li>
          <li class="luggage-item">
            <div>
              <span class={{ 'luggage-item': true, '-included': bags.suitcase > 0 }}>
                <div class="luggage-item-icon eva-3-icon-suitcase-filled -eva-3-icon-md"></div>
                <div class="luggage-item-content">
                  <div class="luggage-item-title">
                    {bags.suitcase > 0 ? i18n.t.flightDetailModal.baggage.suitcase.included.title : i18n.t.flightDetailModal.baggage.suitcase.notIncluded.title}
                  </div>
                  <div class="luggage-item-description">
                    <p>
                      {bags.suitcase > 0
                        ? i18n.t.flightDetailModal.baggage.suitcase.included.description(bags.suitcase)
                        : i18n.t.flightDetailModal.baggage.suitcase.notIncluded.description}
                    </p>
                  </div>
                </div>
              </span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
}
